import React from 'react';
import { useTranslation } from 'react-i18next';
const MbmIcons = (props) => {
    const { t } = useTranslation();
    return (React.createElement("ul", { className: "mbm-icons" }, props.icons.map((icon, i) => (React.createElement("li", { id: icon.id, key: i },
        React.createElement("img", { src: icon.image, alt: "" }),
        React.createElement("span", null, t(icon.label)))))));
};
export default MbmIcons;
